import { useAvailableReportsQuery } from 'generated/graphql';

import { getReports } from './reportDefinitions';

const useAvailableReportTypes = () => {
  const { data: availableReports, loading } = useAvailableReportsQuery();
  const availableReportTypes = new Set(
    (availableReports?.reports ?? []).map((report) => report.type)
  );
  return { availableReportTypes, loading };
};

export const useAvailableReportDefinitions = (organizationName: string) => {
  const allReportDefintions = getReports(organizationName);
  const { availableReportTypes, loading } = useAvailableReportTypes();
  const reportDefinitions = allReportDefintions.filter((reportDefinition) =>
    availableReportTypes.has(reportDefinition.type)
  );
  return { reportDefinitions, loading };
};
